import { KeyValue, NgIf, NgStyle }                      from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit }   from '@angular/core';
import { MatDialog }                                    from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed }                 from '@ngneat/until-destroy';
import { LetDirective }                                 from '@ngrx/component';
import { Store }                                        from '@ngrx/store';
import { Caisse }                                       from '@shared/classes/caisse';
import { Produit }                                      from '@shared/classes/produit';
import { User }                                         from '@shared/classes/user';
import { EnumOuiNon }                                   from '@shared/enums/enumOuiNon';
import { capitalize, merge, stringIsNotNull }           from '@shared/helper/LDHelper';
import { BehaviorSubject, combineLatest, forkJoin, of } from 'rxjs';
import { filter, switchMap }                            from 'rxjs/operators';
import { CAISSE }                                       from 'src/app/components/main/self-care/self-care.constants';
import { ButtonNormalComponent }                        from 'src/app/shared/components/button/button-normal/button-normal.component';
import { isDeveloppement, isRecette }                   from 'src/app/shared/constants/sharedFrontConstants';
import { upsertTarificationSelfcare }                   from 'src/app/shared/ngrx/store/actions/tarification.action';
import { selectProduits }                               from 'src/app/shared/ngrx/store/selectors/bilan.selector';
import { selectQueryParams }                            from 'src/app/shared/ngrx/store/selectors/config.selector';
import { selectPeriodicite, selectTarificationFinale }  from 'src/app/shared/ngrx/store/selectors/tarif.selector';
import { selectState, selectUser }                      from 'src/app/shared/ngrx/store/selectors/user.selector';
import { ExpansionBottomColorPipe }                     from 'src/app/shared/pipe/expansion-bottom-color.pipe';
import { FooterLibelleSelfcarePipe }                    from 'src/app/shared/pipe/footer-libelle-selfcare.pipe';
import { MntFormattedPipe }                             from 'src/app/shared/pipe/mntFormatted.pipe';
import { SizeBottomExpansion }                          from 'src/app/shared/pipe/sizeBottomExpansion';
import { QueryParams }                                  from 'src/app/shared/queryParams/queryParams';
import { SharedService }                                from 'src/app/shared/services/shared/shared.service';
import { Etape4_trackingEnum }                          from 'src/app/shared/services/trackingService/button_tracking.enum';
import { TrackingService }                              from 'src/app/shared/services/trackingService/tracking.service';
import { Helper }                                       from 'src/app/shared/utils/helper';
import { LocalStorageUtil }                             from 'src/app/shared/utils/localStorageUtil';
import { HeaderSelfcareComponent }                      from '../../self-care/header-selfcare/header-selfcare.component';
import { FormuleProduct }                               from '../../steps/step-five/formule-product';
import { HeaderSelfcareParameters }                     from '../header-selfcare/header-selfcare-parameters';
import { SelfCareService }                              from '../self-care.service';

import { HeaderPreconisationSelfcareComponent }        from './header-preconisation-selfcare/header-preconisation-selfcare.component';
import { TARIFICATION_SELFCARE, TypeHeaderParameters } from './preconisation-selfcare.constants';
import { PreconisationSelfcareHelper }                 from './preconisation-selfcare.helper';
import { SelfcareTextPrecoComponent }                  from './selfcare-text-preco/selfcare-text-preco.component';

@UntilDestroy ()
@Component ({
              selector:        'app-preconisation-selfcare',
              templateUrl:     './preconisation-selfcare.component.html',
              styleUrls:       ['./preconisation-selfcare.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                NgIf,
                HeaderSelfcareComponent,
                MntFormattedPipe,
                ExpansionBottomColorPipe,
                FooterLibelleSelfcarePipe,
                SizeBottomExpansion,
                NgStyle,
                LetDirective,
                SelfcareTextPrecoComponent,
                HeaderPreconisationSelfcareComponent,
                ButtonNormalComponent,
              ],
              providers:       [],
            })
export class PreconisationSelfcareComponent implements OnInit {
  public isActive: boolean;
  public selectProduits$         = this._store.select (selectProduits);
  public selectUser$             = this._store.select (selectUser);
  public products: KeyValue<string, boolean>[];
  public arTypeHeaderParameters$: BehaviorSubject<TypeHeaderParameters[]>;
  public eligibites$: BehaviorSubject<HeaderSelfcareParameters[]>;
  public listFormulesExpansionProduct: FormuleProduct[];
  public eligibitesEmprunt: boolean;
  public selectTarificationDone$ = this._store.select (selectTarificationFinale);
  public selectPeriodicite$      = this._store.select (selectPeriodicite);
  public isDeveloppement                    = isDeveloppement ();

  constructor (
    private _store: Store,
    protected dialog: MatDialog,
    private trackingService: TrackingService,
    private _datasService: SharedService,
    private _selfCareService: SelfCareService,
  ) {
    this.arTypeHeaderParameters$ = new BehaviorSubject<TypeHeaderParameters[]> ([]);
    this.eligibites$             = new BehaviorSubject<HeaderSelfcareParameters[]> (new Array<HeaderSelfcareParameters> ());
    this.eligibitesEmprunt       = false;
    this.isActive                = true;
    this.products                = new Array<KeyValue<string, boolean>> ();
  }

  ngOnInit (): void {
    const _self = this;
    this.load ();
  };

  accordion () {
    this.isActive = !this.isActive;
  }

  openDialogConseiller (user: User, produits: Produit[]) {
    this.trackingService.trackButtonClick (Etape4_trackingEnum.RAPPEL_CONSEILLER);
    const civilite    = Helper.getLittleCivilite (user.civilite);
    const fileNamePdf = `${civilite} ${capitalize (user.nom)} - Votre_bilan_prevoyance_personnalise_Groupama.pdf`;
    this._selfCareService.dialogConseiller (user, fileNamePdf, produits);
  }

  onChangeProduct (event: KeyValue<string, boolean>) {
    const products = merge (this.products, [event]);
    this.products  = products;
    this.load (products);
  }

  private load (products: KeyValue<string, boolean>[] = []) {
    const _self = this;
    combineLatest ([
                     _self._store.select (selectState),
                     _self._store.select (selectUser),
                     _self._store.select (selectQueryParams),
                   ]).pipe (
      untilDestroyed (this),
      filter (([state, user, queryParams]: [EnumOuiNon, User, QueryParams]) => {
        return state === EnumOuiNon.OUI && user && stringIsNotNull (user.nom);
      }),
      switchMap (([state, user, queryParams]: [EnumOuiNon, User, QueryParams]) => {
        return forkJoin ([
                           of (user),
                           of (queryParams),
                           this._datasService.getCaisses (EnumOuiNon.NON),
                         ]);
      }),
    ).subscribe ({
                   next: ([user, queryParams, caisses]: [User, QueryParams, Caisse[]]) => {
                     _self.check (user, queryParams, caisses, products);
                   },
                 });
  }

  private check (user: User, queryParams: QueryParams, caisses: Caisse[], event: KeyValue<string, boolean>[]) {
    const caisse = CAISSE (user.codepostal, caisses);
    if (caisse) {
      LocalStorageUtil.saveCaisse (caisse);

      const result                      = PreconisationSelfcareHelper.load (user, queryParams, event, caisse);
      this.listFormulesExpansionProduct = result.listFormulesExpansionProduct;
      this.eligibitesEmprunt            = PreconisationSelfcareHelper.isEligibleEmprunt (user);

      this.arTypeHeaderParameters$.next (result.arTypeHeaderParameters);
      this.eligibites$.next (result.headerSelfcare);


      this._store.dispatch (upsertTarificationSelfcare ({
                                                          caisse:                           caisse,
                                                          typeTarificationParametersPhaseB: result.tarificationsParameters,
                                                          user,
                                                          periodicite:                      TARIFICATION_SELFCARE.periodicite,
                                                        }));
    }
  }

  protected readonly SizeBottomExpansion = SizeBottomExpansion;
}
